import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

const HomeMap = ({ type, mode, className, style }) => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "home/map-mobile.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, toFormat: JPG, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Img
      fluid={data.placeholderImage.childImageSharp.fluid}
      placeholderClassName={type !== "gallery" ? undefined : "placeholder-none"}
      objectFit={mode || "cover"}
      className={className}
      style={style}
    />
  );
};

export default HomeMap;
